import '../ui/index';
import { readConfig } from './config';
import { mountWidget, type WidgetApi } from './widget';

const w = window as unknown as { __osviChatWidget?: boolean; OsviChatConfig?: unknown; OsviChat?: WidgetApi & { q?: unknown[][] } };
const script = document.currentScript as HTMLScriptElement | null;
if (!w.__osviChatWidget) {
  const config = readConfig(script, w.OsviChatConfig);
  if (!config.agentId) console.error('[osvi-chat] data-agent is required');
  else {
    const queued = Array.isArray(w.OsviChat?.q) ? [...w.OsviChat.q] : [];
    const api = mountWidget(config); w.OsviChat = api;
    for (const entry of queued) {
      if (!Array.isArray(entry)) continue;
      const method = entry[0];
      if (method === 'open' || method === 'close' || method === 'toggle') api[method]();
    }
  }
}
